import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: "/:businessType/:businessId",
      name: "index",
      component: () => import("/src/views/home.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/success/:businessType",
      name: "success",
      component: () => import("/src/views/result.vue"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/e/success",
      name: "evaluationSuccess",
      component: () => import("/src/views/evaluation-success.vue"),
      meta: {
        requiresAuth: false,
        skipAnalytics: true,
      },
    },
    {
      path: "/e/error",
      name: "evaluationError",
      component: () => import("/src/views/evaluation-error.vue"),
      meta: {
        requiresAuth: false,
        skipAnalytics: true,
      },
    },
    {
      path: "/e/:businessId?",
      name: "evaluation",
      component: () => import("/src/views/evaluation.vue"),
      meta: {
        requiresAuth: false,
        skipAnalytics: true,
      },
    },
    {
      path: "/",
      name: "indexPage",
      component: () => import("/src/views/index.vue"),
    },
  ],
});
export default router;
